<template>
  <div id="app">
    <GlobalWatermark />

    <router-view/>
  </div>
</template>

<script>
// 引入刚刚剥离出去的水印组件
import GlobalWatermark from '@/components/GlobalWatermark/index.vue';

export default {
  name: 'app',
  components: {
    GlobalWatermark
  }
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
</style>

<style>
/* 强制修复 Element UI 弹窗内部文字对比度不可见问题 */
.el-dialog__body,
.el-dialog__title {
  background-color: #ffffff !important;
  color: #333333 !important;
}

.el-dialog__body * {
  color: inherit; /* 让表格等子元素继承深色 */
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
